import { Building2, Home, Linkedin, UserSearch } from 'lucide-react'

/**
 * Sources de recherche de la page Prospection. Chaque source a son formulaire (et sa suite),
 * et ses résultats arrivent dans une base du CRM (`crmBase`, cf. features/crm/bases.js).
 * `module` : droit nécessaire (features/access/modules.js).
 */
export const PROSPECTION_SOURCES = [
  {
    key: 'b2b',
    code: 'B2B',
    name: 'B2B',
    note: 'Recherche ciblée',
    label: 'Prospects B2B',
    title: 'Entreprises et décideurs',
    description: 'Recherche par métier, ville et secteur, puis enrichissement des contacts (email, téléphone).',
    icon: Building2,
    module: 'prospects',
    crmBase: 'prospects',
  },
  {
    key: 'linkedin',
    code: 'in',
    name: 'LinkedIn',
    note: 'Avec votre compte',
    label: 'Prospects LinkedIn',
    title: 'Profils LinkedIn',
    description: 'Recherche de personnes avec votre compte LinkedIn ; les profils choisis arrivent dans vos prospects.',
    icon: Linkedin,
    module: 'prospects',
    crmBase: 'prospects',
  },
  {
    key: 'immobilier',
    code: 'Im',
    name: 'Immobilier',
    note: 'LeBonCoin et PAP',
    label: 'Annonces immobilières',
    title: 'Biens à vendre ou à louer',
    description: 'Scraping LeBonCoin et PAP par ville, type de bien, prix et surface.',
    icon: Home,
    module: 'immobilier',
    crmBase: 'immobilier',
  },
  {
    key: 'france-travail',
    code: 'FT',
    name: 'France Travail',
    note: 'Profils et CV',
    label: 'Candidats France Travail',
    title: 'Profils et CV de candidats',
    description: 'Le robot récupère les CV sur France Travail ; chaque CV est analysé et le candidat ajouté au CRM.',
    icon: UserSearch,
    module: 'france_travail',
    crmBase: 'candidats-ft',
  },
]
